import Vue from 'vue';
import { useCodeTypeStore } from '@/stores/code-type/code-type';

Vue.directive('xer-code-type', {
  bind(el, binding) {
    const {
      value: { groepnaam, code }
    } = binding;
    const codeTypeStore = useCodeTypeStore();
    codeTypeStore
      .getCodeTypeKorteText(groepnaam, code)
      .then((korteTekst) => (el.innerHTML = korteTekst));
  }
});
